var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.81,
    height: 18.735,
    viewBox: "0 0 21.81 18.735",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a4a4a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(-499.792 -59.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "cls-1",
    d: "M574.969,60.82l-1.529-.952a.36.36,0,0,0-.5.052l-.641,1.03h0l-5.492,8.821a2.777,2.777,0,0,0-.123.7c-.042.628-.1,1.484-.112,1.593s-.033.348.074.415.311-.049.409-.119.836-.488,1.378-.8a1.656,1.656,0,0,0,.528-.346l5.539-8.9h0l.641-1.03A.36.36,0,0,0,574.969,60.82ZM573.3,60.5l1.162.723-.317.509-1.162-.723Zm-6,9.954.875.544c-.42.241-.728.419-.948.547C567.246,71.3,567.262,70.941,567.3,70.459Zm1.3.169-1.158-.72,5.212-8.372,1.158.721Z",
    transform: "translate(-53.578)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(499.792 63.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-1",
    d: "M502.176,91.739a.512.512,0,0,1-.512-.512V88.944h-.624a1.249,1.249,0,0,1-1.248-1.248V77.5a1.246,1.246,0,0,1,1.245-1.245h15.188a.409.409,0,0,1,0,.819H501.037a.427.427,0,0,0-.426.426V87.7a.43.43,0,0,0,.429.429h1.033a.409.409,0,0,1,.409.409v2.037l2.811-2.351a.41.41,0,0,1,.263-.1h12.191a.428.428,0,0,0,.426-.429V80.759a.409.409,0,1,1,.819,0V87.7a1.248,1.248,0,0,1-1.245,1.248H505.7l-3.2,2.676A.514.514,0,0,1,502.176,91.739Z",
    transform: "translate(-499.792 -76.256)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(505.282 67.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "cls-1",
    d: "M535.392,97.794h-7.4a.409.409,0,0,1,0-.818h7.4a.409.409,0,1,1,0,.818Z",
    transform: "translate(-527.581 -96.976)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(0 1.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "cls-1",
    d: "M534.442,107.194H527.99a.409.409,0,0,1,0-.819h6.452a.409.409,0,0,1,0,.819Z",
    transform: "translate(-527.581 -106.375)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(0 3.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    className: "cls-1",
    d: "M527.99,116.591a.409.409,0,0,1,0-.818h6.179a.409.409,0,0,1,0,.819Z",
    transform: "translate(-527.581 -115.772)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedback);
export default __webpack_public_path__ + "static/media/icon-feedback.e51dc1a16288ad01f4b81d8d2b9281a8.svg";
export { ForwardRef as ReactComponent };